import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Finca } from '@models/finca';
import { SuperHttpClientProvider } from '@app/core/http';
import { DefaultEditor } from '@app/shared/smart-table/ng2-smart-table';
import { tap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-selectfinca',
  templateUrl: './selectfinca.component.html',
  styleUrls: ['./selectfinca.component.scss']
})
export class SelectfincaComponent extends DefaultEditor
  implements OnInit, AfterViewInit {
  public fincas: Finca[] = [];

  constructor(private $shttp: SuperHttpClientProvider) {
    super();
  }

  ngOnInit() {
    this.$shttp.default
      .get('/admin/finca')
      .pipe(tap(data => (this.fincas = data)))
      .subscribe();
  }

  ngAfterViewInit() {}
}
